import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { employeeModel } from '~/entities/Employee'
import {
  editEmployeeModel,
  EditEmployee,
} from '~/features/Employees/EditEmployee'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'

export const EditEmployeePage = () => {
  const { t } = useTranslation()
  const { employeeId } = useParams<{ employeeId: string }>()

  const isLoading = useStore(employeeModel.requestFx.pending)
  const employeeName = useStoreMap(editEmployeeModel.$employee, (employee) =>
    employee?.getName(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { titleI18n: 'employees', link: '/settings/employees' },
      { title: employeeName || '' },
    ],
    [employeeName],
  )

  const error = employeeModel.useEmployeeError(employeeId as string)

  if (!employeeId || error) {
    return <NotFound message={t('alert.employee load error')} />
  }

  return (
    <PageContainer title={t('employee card')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{employeeName}</PageTitle>
      </Container>

      <EditEmployee employeeId={employeeId} />
    </PageContainer>
  )
}
